module.exports = __webpack_public_path__ + "assets/bc227deed1e331540eb6cb0c6d65ae7c.svg";